import ClusterProductListingPanel from "./clusterProductListingPanel.container";

export default ClusterProductListingPanel;
